import {
  GET_DRUG_RULES_SETTINGS,
  GET_DRUG_RULES_SETTINGS_ERROR,
  GET_DRUG_RULES_SETTINGS_SUCCESS,
  SET_DRUG_RULES_SETTINGS_BY_USER_ID,
} from './drugRulesSettingsConstants'

const initialState = {
  drugScreenUIForPatient: null,
  patientSettings: null,
  settingsPerState: null,
  loading: false,
}
export default function drugRulesSettingsReducer(state = initialState, action = {}) {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case GET_DRUG_RULES_SETTINGS:
      return {
        ...state,
        loading: true,
      }
    case GET_DRUG_RULES_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        settingsPerState: action.payload?.SettingsPerState,
      }
    case SET_DRUG_RULES_SETTINGS_BY_USER_ID:
      return {
        ...state,
        patientSettings: {
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          ...state.patientSettings,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.payload.patientId]: state?.settingsPerState?.find(
            // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
            (stateSetting) => stateSetting.StateCode === action.payload.patientHomeAddressState,
          ),
        },
      }
    case GET_DRUG_RULES_SETTINGS_ERROR: {
      return {
        ...state,
        loading: false,
      }
    }
    default:
      return state
  }
}
